import { consequencesActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  consequencesList: null,
  consequencesDetail: null,
  saved_consequences: null,
  deleted_consequences: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case consequencesActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case consequencesActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
  case consequencesActionTypes.save_consequences.REQUEST:
    return {
      ...state,
      loading: true,
      saved_consequences: null,
    };
  case consequencesActionTypes.save_consequences.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_consequences: payload,
    };
  case consequencesActionTypes.get_consequencesList.REQUEST:
    return {
      ...state,
      loading: true,
      consequencesList: null,
    };
  case consequencesActionTypes.get_consequencesList.SUCCESS:
    return {
      ...state,
      loading: false,
      consequencesList: payload,
    };
  case consequencesActionTypes.get_consequencesDetail.REQUEST:
    return {
      ...state,
      loading: true,
      consequencesDetail: null,
    };
  case consequencesActionTypes.get_consequencesDetail.SUCCESS:
    return {
      ...state,
      loading: false,
      consequencesDetail: payload,
    };
  case consequencesActionTypes.delete_consequences.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_consequences: null,
    };
  case consequencesActionTypes.delete_consequences.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_consequences: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Consequences/reducers/consequencesReducer.js